import React from "react";
import LogoSection from "../../components/LogoSection/LogoSection";
import ConocenosSection from "../../components/ConocenosSection/ConocenosSection";
import NuestrosServiciosSection from "../../components/NuestrosServiciosSection/NuestrosServiciosSection";
import ContactSection from "../../components/ContactSection/ContactSection";
import ColeccionBodasSection from "../../components/ColeccionBodasSection/ColeccionBodasSection";
import EventosSection from "../../components/EventosSection/EventosSection";

export default function HomePage() {
    return (
        <div>
            <LogoSection/>
            <ConocenosSection/>
            <NuestrosServiciosSection/>
            <ColeccionBodasSection/>
            <EventosSection/>
            <ContactSection/>
        </div>
    )
}